import { RoleType } from '@addmile/backend-client';

import { ROUTES } from '../routes';

export type SignInType = 'coach' | 'user';

export const defineSignInRoute = (role: RoleType | null): { route: string } => {
  if (role === RoleType.Coach) {
    return { route: ROUTES.COACH };
  }
  return { route: ROUTES.HOME };
};
